import { flow, ReadonlyArray, Runtime } from "fp";

import * as Data from "~/Data";
import * as Messaging from "~/Messaging";
import { Request } from "~/Request";

export namespace Get {
  type Options = {
    readonly company: Data.Reference.Reference;
    readonly driver: Data.Reference.Reference;
  };

  export const request = (
    options: Options
  ): Data.Cache.Request<readonly Messaging.Message[]> =>
    flow(
      Request.fromConfig({ endpoint: endpoint(options) }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Messaging.Response.runtime())),
      Request.onSuccess((response) =>
        Data.Cache.fromData({
          [options.driver.id]: ReadonlyArray.map(Messaging.Response.decode)(
            response
          ),
        })
      )
    );

  const endpoint = ({ company, driver }: Options) =>
    `/companies/${company.id}/drivers/${driver.id}/messages`;
}
